export default __webpack_public_path__ + "static/notification-m-7086513405916bce58531ae7ef7f03ce.webp";